import { FaSyncAlt, FaTimes } from 'react-icons/fa';
import styles from './UpdateToast.module.css';

export interface UpdateToastProps {
  /** 新しいバージョンが待機しているか */
  open: boolean;
  /** ［更新する］。新 SW を確定させてリロードする */
  onReload: () => void;
  /** ［あとで］。同じバージョンでは再表示しない */
  onDismiss: () => void;
}

/**
 * 新しいバージョンが配信されたことを知らせるトースト（表示専用）。
 *
 * 自動では消さない。見逃すと古いバンドルを使い続けてしまうため、
 * ユーザーがどちらかのボタンを押すまで出したままにする。
 * 逆に自動リロードもしない（アップロード中・入力中の内容を失わせない）。
 */
const UpdateToast = ({ open, onReload, onDismiss }: UpdateToastProps) => {
  if (!open) return null;

  return (
    <div className={styles['update-toast']} role="status" aria-live="polite" data-testid="update-toast">
      <div className={styles['update-toast-body']}>
        <span className={styles['update-toast-icon']} aria-hidden="true">
          <FaSyncAlt />
        </span>

        <div className={styles['update-toast-text']}>
          <p className={styles['update-toast-title']}>新しいバージョンがあります</p>
          <p className={styles['update-toast-description']}>
            アップロードや入力の途中でないことを確認してから更新してください。
          </p>
        </div>

        <div className={styles['update-toast-actions']}>
          <button
            type="button"
            className={styles['update-toast-reload']}
            onClick={onReload}
            data-testid="update-toast-reload"
          >
            更新する
          </button>
          <button
            type="button"
            className={styles['update-toast-dismiss']}
            onClick={onDismiss}
            aria-label="あとで更新する"
            data-testid="update-toast-dismiss"
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateToast;
